export default __webpack_public_path__ + "static/media/SALogo.c809a31b.png";